<template>
  <nav>
    <ul class="pagination my-2 justify-content-center pagination-container">
      <li class="page-item" :class="{ disabled: isLoading || currentPage === 1 }">
        <button class="page-link" :disabled="isLoading || currentPage === 1" @click.stop.prevent="goToPage(1)">« 最初へ</button>
      </li>
      <li class="page-item" :class="{ disabled: isLoading || currentPage === 1 }">
        <button class="page-link" :disabled="isLoading || currentPage === 1" @click.stop.prevent="goToPage(currentPage - 1)">‹ 前へ</button>
      </li>

      <li
        v-for="page in visiblePages"
        :key="page"
        class="page-item"
        :class="{ active: currentPage === page, disabled: page === '...' || isLoading }"
      >
        <button
          v-if="page !== '...'"
          class="page-link"
          :disabled="isLoading || page === currentPage"
          @click.stop.prevent="goToPage(page)"
        >
          {{ page }}
        </button>
        <span v-else class="page-link">…</span>
      </li>

      <li class="page-item" :class="{ disabled: isLoading || currentPage === totalPages }">
        <button class="page-link" :disabled="isLoading || currentPage === totalPages" @click.stop.prevent="goToPage(currentPage + 1)">次へ ›</button>
      </li>
      <li class="page-item" :class="{ disabled: isLoading || currentPage === totalPages }">
        <button class="page-link" :disabled="isLoading || currentPage === totalPages" @click.stop.prevent="goToPage(totalPages)">最後へ »</button>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      lastRequestedPage: null
    };
  },
  computed: {
    visiblePages() {
      const safeTotalPages = this.totalPages > 0 ? this.totalPages : 1;
      const range = 2;
      const pages = [];

      if (safeTotalPages <= 7) {
        for (let i = 1; i <= safeTotalPages; i++) pages.push(i);
      } else {
        if (this.currentPage > 3) pages.push(1, '...');
        const start = Math.max(2, this.currentPage - range);
        const end = Math.min(safeTotalPages - 1, this.currentPage + range);
        for (let i = start; i <= end; i++) pages.push(i);
        if (this.currentPage < safeTotalPages - 2) pages.push('...', safeTotalPages);
      }

      return pages;
    }
  },
  methods: {
    goToPage(page) {
      const safeTotalPages = this.totalPages > 0 ? this.totalPages : 1;
      if (
        this.isLoading ||
        typeof page !== 'number' ||
        page < 1 ||
        page > safeTotalPages ||
        page === this.currentPage
      ) {
        return;
      }

      this.isLoading = true;
      this.lastRequestedPage = page;
      this.$emit('change-page', page);
    }
  },
  watch: {
    currentPage(newPage) {
      if (newPage === this.lastRequestedPage) {
        this.isLoading = false;
        this.lastRequestedPage = null;
      }
    },
    totalPages() {
      this.isLoading = false;
      this.lastRequestedPage = null;
    }
  }
};
</script>

<style scoped>
.page-item .page-link {
  font-size: 12px;
}

.page-item.disabled .page-link {
  pointer-events: none;
  opacity: 0.5;
}

.page-item.active .page-link {
  background-color: #0d6efd;
  color: white;
  border-color: #0d6efd;
}
</style>
